import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Card = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, children } = _a, props = __rest(_a, ["as", "className", "children"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card', className) }), children));
});
Card.displayName = 'Card';
const CardHeader = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, children, actions } = _a, props = __rest(_a, ["as", "className", "children", "actions"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card__header', className) }),
        React.createElement("div", { className: 'card__header__content' }, children),
        actions && React.createElement(CardActions, null, actions)));
});
CardHeader.displayName = 'CardHeader';
const CardActions = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, children } = _a, props = __rest(_a, ["as", "className", "children"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card__actions', className) }), children));
});
CardActions.displayName = 'CardActions';
const CardContent = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, children } = _a, props = __rest(_a, ["as", "className", "children"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card__content', className) }), children));
});
CardContent.displayName = 'CardContent';
const CardFooter = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className, children } = _a, props = __rest(_a, ["as", "className", "children"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card__footer', className) }), children));
});
CardFooter.displayName = 'CardFooter';
const CardSubtitle = React.forwardRef((_a, ref) => {
    var { className, children, as: Component = 'div' } = _a, props = __rest(_a, ["className", "children", "as"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card__subtitle', className) }), children));
});
CardSubtitle.displayName = 'CardSubtitle';
const CardTitle = React.forwardRef((_a, ref) => {
    var { className, as: Component = 'h5', children } = _a, props = __rest(_a, ["className", "as", "children"]);
    return (React.createElement(Component, Object.assign({ ref: ref }, props, { className: clsx('card__title', className) }), children));
});
CardTitle.displayName = 'CardTitle';
export { Card, CardHeader, CardActions, CardContent, CardFooter, CardSubtitle, CardTitle, };
export * from './types';
//# sourceMappingURL=index.js.map